import React, { FC, useEffect } from 'react'
import Helmet from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../states/containers/store'
import { fetchMailDelivery, fetchSystem } from '../../../../states/containers/setting/systemSlice'
import OauthInfo from '../../../components/setting/OauthInfo'
import SlackInfo from '../../../components/setting/SlackInfo'

const Index: FC = () => {
  const dispatch = useDispatch()
  const { login } = useSelector<RootState, RootState>((state: RootState) => (state))

  useEffect(() => {
    if (!login.accessToken) return
    dispatch(
      fetchSystem(
        () => { /* nothing */ },
      ),
    )
    dispatch(fetchMailDelivery())
  }, [login.accessToken])

  return (
    <section className="setting_page">
      <Helmet>
        <title>Qasee - 設定 - 個人設定 - 外部サービス連携</title>
      </Helmet>
      <section className="breadcrumb">
        設定
        &nbsp;&gt;&nbsp;
        個人設定
        &nbsp;&gt;&nbsp;
        外部サービス連携
        &nbsp;
      </section>
      <section className="page_header">
        <h1>
          外部サービス連携
        </h1>
      </section>
      <section className="page_description">
        <p>
          外部サービスとQaseeを連携して、カレンダーの同期やSSO・通知設定が可能となります。
        </p>
      </section>
      <section className="page_contents content-area">
        <div className="content-block">
          <div className="block-detail">
            <div className="block-header">
              <div className="title">
                Google・Microsoft365連携
              </div>
            </div>
            <div className="block-detail">
              <div className="description">
                <p>Googleアカウント または Microsoft365アカウント と連携します。</p>
                <p>連携すると、カレンダー情報の連携とSSO(シングルサインオン)が可能になります。</p>
              </div>
              <OauthInfo />
            </div>
          </div>
        </div>
      </section>
      <section className="page_contents content-area">
        <div className="content-block">
          <div className="block-detail">
            <div className="block-header">
              <div className="title">
                Slack連携
              </div>
            </div>
            <div className="block-detail">
              <div className="description">
                <p>Slackアカウントと連携します。</p>
                <p>連携すると、各種通知をSlackに発信することがが可能になります。</p>
              </div>
              <SlackInfo />
            </div>
          </div>
        </div>
      </section>
    </section>
  )
}

export default Index
